var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#F3F5F7",
    stroke: "#E6E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1935 31.2004C29.8614 28.3309 32.9789 26.4004 36.5495 26.4004C40.5979 26.4004 44.0638 28.8822 45.4949 32.4004M31.1233 32.4004H26.3V27.6004M44.8066 40.8004C43.1387 43.6698 40.0212 45.6004 36.4506 45.6004C32.4022 45.6004 28.9363 43.1186 27.5052 39.6004M41.8768 39.6004H46.7001V44.4004",
    stroke: "#F8009E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsExchange);
export default __webpack_public_path__ + "static/media/DetailsExchange.0f946dd80e031f821037f0f26a4192d5.svg";
export { ForwardRef as ReactComponent };